import React from 'react';

import { IconProps } from './types';

export const ShieldYesIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.075"
    height="22.535"
    viewBox="0 0 20.075 22.535"
    ref={forwardedRef}
    {...props}
  >
    <g id="shield_yes" transform="translate(-34.047 -22.7)">
      <path
        id="Path_569"
        data-name="Path 569"
        d="M93.719,97.376l-3.989,3.989-1.7-1.7a.826.826,0,1,0-1.168,1.168l2.292,2.292a.825.825,0,0,0,1.168,0L94.9,98.555a.834.834,0,0,0-1.179-1.179Z"
        transform="translate(-46.784 -66.235)"
      />
      <path
        id="Path_570"
        data-name="Path 570"
        d="M53.855,25.874a.718.718,0,0,0-.529-.606l-9.047-2.535A.993.993,0,0,0,44.1,22.7h-.022a.5.5,0,0,0-.176.033l-9.058,2.524a.718.718,0,0,0-.529.606,34.067,34.067,0,0,0-.044,8.111s.364,3.78,1.829,5.631a14.432,14.432,0,0,0,7.78,5.609,1.086,1.086,0,0,0,.187.022h.022a.546.546,0,0,0,.187-.022,14.392,14.392,0,0,0,7.78-5.609c1.466-1.851,1.829-5.631,1.829-5.631A33.637,33.637,0,0,0,53.855,25.874Zm-1.554,8.1h0a10.947,10.947,0,0,1-1.576,4.705h0a12.438,12.438,0,0,1-6.645,4.8,12.48,12.48,0,0,1-6.645-4.8h0a11.031,11.031,0,0,1-1.565-4.705h0a30.6,30.6,0,0,1,.033-7.24l8.177-2.27v.011l.011-.011.011.011v-.011l8.177,2.27A30.026,30.026,0,0,1,52.3,33.973Z"
      />
    </g>
  </svg>
));

ShieldYesIcon.displayName = 'ShieldYesIcon';

export default ShieldYesIcon;
